import * as React from 'react'
import { TerminalScoreContext } from '../TerminalScoreProvider';
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { IStableTerminalNode } from '../model/TerminalScore';
import TerminalStat from './TerminalStat';


type Props = {
  nodeId: string,
  className?: string
}

const MINIMUM_STABLE_OUT_NODES = 2;

const TerminalMinimumStableOutPeers: React.FC<Props> = ({ nodeId, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);


  const graphNode = graph.getNode(nodeId);
  const terminalNode = terminalScore.getNode(nodeId);
  const interpreter = new TerminalNodeInterpreter(terminalNode);

  const status = terminalScore.getNodeStatus(nodeId);
  const isJudged = status === 'scored' || status === 'stable';
  let stableNodesCount = 0
  if (isJudged) {
    stableNodesCount = (terminalNode as IStableTerminalNode).stable_outbound_peers.length;
  }

  const isBelowMinimum = stableNodesCount < MINIMUM_STABLE_OUT_NODES;

  let value = '-';
  if (isJudged) {
    value = stableNodesCount.toString();
  }

  return (
    <TerminalStat label="Good outbound peers" value={value} isMatched={!isBelowMinimum} />
  );
}

export default TerminalMinimumStableOutPeers;

